import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import HtmlElement from '../HtmlElement';

const defaultProps = {
  className: '',
};

const propTypes = {
  type: PropTypes.oneOf([
    'text',
    'email',
    'phone',
  ]).isRequired,
  className: PropTypes.string,
};

const Input = ({
  type,
  className,
  ...rest
}) => (
  <HtmlElement
    type={type}
    tagName="input"
    className={classnames(
      'focus:outline-none',
      className,
    )}
    {...rest}
  />
);

Input.defaultProps = defaultProps;
Input.propTypes = propTypes;

export default Input;
